/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.models {
    export class TreeConfigurationItem {
        public stepId: string;
        public claimId: string;
        public claimUniqueId: string;
        public relatedClaimProcessTypeId: string;
        public processDataId: string;
        public conditionId: string;
        public calculationId: string;
        public constantId: string;
        public queryId: string;
        public schemaPropertyId: string;
        public objectSchemaId: string;
        public staticDocumentId: string;
        public emailGroupId: string;
        public timeTrackerId: string;
        public systemCodeId: string;
        public claimGroupId: string;
        public interProcessApiId: string;

        public listSectionId: string;
        public listPropertyId: string;

        public isList: boolean;
        public isClaimWithValue: boolean;
        public isRequired: boolean;
        public text: string;
        public variableType: Wars.Domain.Model.Codes.Enums.VariableType;
        public treeItemSource: Wars.Domain.Model.Codes.Enums.TreeItemSource;
        public isSystemLevel: boolean;
        public placeholder: Wars.Domain.Model.Codes.Enums.Placeholder;
        public complexObjectProperty: Wars.Domain.Model.Codes.Enums.ComplexObjectProperty;
        public userClaimDefinitionId;
    }
}